import { BUILD } from './build';

const APP_NAME = 'com.apple.classical.music';
const APP_DELEGATE = 'web-classical-music-app';
export const PERF_MUSIC_CLASSICAL_TOPIC = 'xp_amp_music-classical_perf';

export const config = {
    baseFields: {
        appName: APP_NAME,
        delegateApp: APP_DELEGATE,
        appVersion: BUILD,
        resourceRevNum: BUILD,
    },
    clickstream: {
        constraintProfiles: ['AMPWeb'],
        topic: 'xp_amp_music-classical_main',
    },
    funnel: {
        constraintProfiles: ['AMPFunnel'],
        topic: 'xp_amp_music-classical_unidentified',
    },
    initialURL: null,
};

export const PERF_KIT_CONFIG = {
    topic: PERF_MUSIC_CLASSICAL_TOPIC,
    appName: APP_NAME,
    appVersion: BUILD,
    delegateApp: APP_DELEGATE,
    resourceRevNum: BUILD,
    // TODO: Turn on Perf metrics when we ready
    // rdar://147234043 (Turn on Perf metric for classical)
    suppressPerfKit: true,
};
